import UserService from "rc-app/services/UserService";

export const getRegionDetails = async (email_id) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/realestate/re_agent/profile/${email_id}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getRegionDetailsById = async (region_id) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_region_details/${region_id}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getRegionIds = async (regions) => {
  try {
    const requests = regions.map(async (region) => {
      const encodedRegion = encodeURIComponent(region);
      const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_region_details?region=${encodedRegion}&sort_by=created_at&sort_order=-1&page=0&limit=20`;

      // const response = await fetch(url);
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      console.log("agencyLogo4", data);
      if (data.success && data.re_region_details_list && data.re_region_details_list[0]._id) {
        console.log("AgencyLogo5", data.re_region_details_list[0]._id);
        return data.re_region_details_list[0]._id;
      } else {
        console.warn(`No region ID found for: ${region}`);
        return null;
      }
    });

    const regionIds = await Promise.all(requests);
    
    
    
    return regionIds.filter((id) => id !== null);
  } catch (error) {
    console.error("Error fetching region IDs:", error.message);
    return [];
  }
};
